import React from 'react'

import Link from '@Pure/Link'

import { mergeDeep } from '@root/utility'

export let form =
{
	model: 'provider',
	name: 'provider',
	pattern: 'provider',

	form_title: 'Fournisseur',

	fields:
	{
		agency_code:
		{
			label: 'Code agence'
		},

		order_type:
		{
			label: 'Mode de commande',
			type: 'select',
			options:
			[
				{
					value: 'E-mail'
				},
				{
					value: 'Courrier'
				},
				{
					value: 'Site web'
				}
			]
		},

		'order_type_infos[url]':
		{
			label: 'Adresse url du site',

			show: function (form_data)
			{
				return form_data['provider[order_type]'] === 'Site web';
			}
		},

		'order_type_infos[id]':
		{
			label: 'Identifiant',

			show: function (form_data)
			{
				return form_data['provider[order_type]'] === 'Site web';
			}
		},

		'order_type_infos[password]':
		{
			label: 'Mot de passe',

			show: function (form_data)
			{
				return form_data['provider[order_type]'] === 'Site web';
			}
		},

		infos:
		{
			label: 'Observations',
			type: 'editor',
			images: false
		},

		name:
		{
			label: 'Nom'
		},

		legal_code:
		{
			label: 'Code comptable'
		},

		internal_code:
		{
			label: 'Code interne'
		},

		discount:
		{
			label: 'Remise / Avantages',
			type: 'editor'
		},

		email:
		{
			label: 'E-mail',
			type: 'email'
		},

		requirements:
		{
			label: 'Conditions',
			type: 'select',
			options:
			[
				{
					label: 'Aucunes',
					value: 'none'
				},
				{
					label: 'Montant minimum',
					value: 'cost_minimum'
				},
				{
					label: 'Quantité minimum',
					value: 'amount_minimum'
				}
			]
		},

		requirements_cost:
		{
			label: 'Montant',
			type: 'number',
			show: form_data => form_data['provider[requirements]'] === 'cost_minimum'
		},

		payment_type:
		{
			label: 'Mode de paiement',
			type: 'select',
			options:
			[
				{
					label: 'En différé',
					value: 'differed'
				},
				{
					label: 'À la commande',
					value: 'by_order'
				}
			]
		},

		'order_payment_infos':
		{
			label: 'Paiement par',
			type: 'select',
			options:
			[
				{
					label: 'CB',
					value: 'cc'
				},
				{
					label: 'Chèque',
					value: 'check'
				},
				{
					label: 'Virement',
					value: 'bank_transfert'
				},
				{
					label: 'Prélèvement bancaire',
					value: 'bank_debit'
				}
			],

			show: function (form_data)
			{
				return form_data['provider[payment_type]'] === 'by_order';
			}
		},

		phone:
		{
			label: 'Téléphone',
			type: 'tel'
		},

		mobile:
		{
			label: 'Téléphone mobile',
			type: 'tel'
		},

		'contacts[name]':
		{
			type: 'text'
		},

		'contacts[phone]':
		{
			type: 'tel'
		},

		'contacts[mobile]':
		{
			type: 'tel'
		},

		'contacts[email]':
		{
			type: 'email'
		},

		'address[line_1]':
		{
			label: 'Adresse'
		},

		'address[line_2]':
		{
			label: 'Complément d\'adresse'
		},

		'address[zip_code]':
		{
			label: 'Code postal'
		},

		'address[city]':
		{
			label: 'Ville'
		}
	},

	create_label: 'Créer ce fournisseur',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce fournisseur&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['provider[name]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (data)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau fournisseur <strong> { data.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-du-catalogue/fournisseurs/' + data.id }>
						Voir le fournisseur
					</Link>
				</div>
			</div>
		);

		return output;
	},

	collapses:
	[
		{
			title: 'Général',
			open: true,
			elements:
			[
				'name',
				'agency_code',
				'internal_code',
				'legal_code',
				'infos',
				'discount'
			]
		},
		{
			title: 'Conditions',
			open: true,
			elements:
			[
				'requirements',
				'requirements_cost'
			]
		},
		{
			title: 'Mode de commande',
			open: true,
			elements:
			[
				'order_type',
				'order_type_infos[url]',
				'order_type_infos[id]',
				'order_type_infos[password]'
			]
		},
		{
			title: 'Mode de paiement',
			open: true,
			elements:
			[
				'payment_type',
				'order_payment_infos'
			],
		},
		{
			title: 'Contact',
			open: true,
			elements:
			[
				'phone',
				'mobile',
				'email',
				{
					type: 'table',
					table_name: 'contacts',
					columns:
					{
						'Nom'      : 'contacts[name]',
						'E-mail'   : 'contacts[email]',
						'Téléphone': 'contacts[phone]',
						'Portable' : 'contacts[mobile]'
					},
					add: true,
					add_label: 'Ajouter'
				}
			]
		},
		{
			title: 'Adresse',
			open: true,
			elements:
			[
				'address[line_1]',
				'address[line_2]',
				'address[zip_code]',
				'address[city]'
			],
		},
	],

	repeatable:
	[
		'contacts'
	]
}

export let list =
{
	model         : 'provider',
	title         : 'Liste des fournisseurs',
	link          : '/gestion-du-catalogue/fournisseurs',
	creation_link : '/gestion-du-catalogue/nouveau-fournisseur',
	creation_label: 'Créer un nouveau fournisseur',
	header_map    :
	{
		'Nom'         : 'name',
		'Code agence' : 'agency_code',
		'Code interne': 'internal_code'
	},
	row_link_base: '/gestion-du-catalogue/fournisseurs/',
	searched_prop: 'name'
}

let config = mergeDeep({ }, form);

config = mergeDeep(config, list);

export default config